import React from "react";

export const EmptyEvent = () => {
  return (
    <>
      <tr>
        <td colSpan={100}>
          <p>
            There doesn't appear to be much here yet! Why not send your Nood to
            your friends?
          </p>
        </td>
      </tr>
    </>
  );
};
